module.exports = __webpack_public_path__ + "static/media/microsoft.363fdd53.svg";